<template>
    <div id="projects" class="projects">
        <transition name="closed-fade">
            <div class="closed-screen" v-if="isClosed">
                <span class="closed-icon">💻</span>
                <p>Vous avez fermé la fenêtre des projets.</p>
                <button @click="isClosed = false">Rouvrir</button>
            </div>
        </transition>
        <transition name="closed-fade">
        <div class="projects-inner" v-if="!isClosed">
        <div class="navigator" :class="{ fullscreen: isFullscreen, minimized: isMinimized }">
            <div class="actions">
                <div class="close" @click="isClosed = true"></div>
                <div class="minus" @click="isMinimized = !isMinimized"></div>
                <div class="zoom" @click="isFullscreen = !isFullscreen"></div>
            </div>

            <div class="content">
                <div class="left" v-show="!isMobile || mobileShowList">

                    <div class="search divider">
                        <input ref="searchInput" type="text" v-model="form.search" placeholder="Rechercher... (⌘K)" />
                    </div>

                    <div class="tech-filter divider">
                        <button class="tech-filter-toggle" @click="techFilterOpen = !techFilterOpen">
                            <font-awesome-icon icon="filter" />
                            <span>Filtrer par techno</span>
                            <span class="filter-count" v-if="selectedTechs.length">{{ selectedTechs.length }}</span>
                            <font-awesome-icon icon="chevron-down" class="chevron" :class="{ open: techFilterOpen }" />
                        </button>
                        <transition name="filter-expand">
                            <div class="tech-chips" v-if="techFilterOpen">
                                <button
                                    v-for="tech in allTechs"
                                    :key="tech"
                                    class="tech-chip"
                                    :class="{ active: selectedTechs.includes(tech) }"
                                    @click="toggleTechFilter(tech)"
                                    :title="tech">
                                    <img :src="require('../assets/img/logos/' + tech + '.png')" :alt="tech" />
                                    <span>{{ tech }}</span>
                                </button>
                            </div>
                        </transition>
                    </div>

                    <!-- Giovanni (contact) - toujours en premier -->
                    <ul class="project-section" v-if="projects[0]">
                        <li
                            :class="[{ active: activeProject === projects[0], notified: notifications[projects[0].key] }]"
                            @click="selectProject(projects[0])">
                            <Avatar :avatar="projects[0].avatar" :color="projects[0].avatarColor" />
                            <div class="project-info">
                                <span class="project-title">{{ projects[0].title }}</span>
                            </div>
                            <span class="notifications" v-if="notifications[projects[0].key]">
                                <font-awesome-icon icon="bell" />
                            </span>
                        </li>
                    </ul>

                    <!-- Projets épinglés -->
                    <template v-if="pinnedVisible.length">
                        <div class="section-label">Épinglés</div>
                        <ul class="project-section">
                            <li
                                v-for="project of pinnedVisible"
                                :key="project.key"
                                :class="[{ active: activeProject === project, notified: notifications[project.key] }]"
                                @click="selectProject(project)">
                                <Avatar :avatar="project.avatar" :color="project.avatarColor" />
                                <div class="project-info">
                                    <span class="project-title">{{ project.title }}</span>
                                    <div class="project-logos" v-if="project.logos && project.logos.length">
                                        <img
                                            v-for="logo in project.logos"
                                            :key="logo"
                                            :src="require('../assets/img/logos/' + logo + '.png')"
                                            :alt="logo"
                                            :title="logo" />
                                    </div>
                                </div>
                                <span class="notifications" v-if="notifications[project.key]">
                                    <font-awesome-icon icon="bell" />
                                </span>
                            </li>
                        </ul>
                    </template>

                    <!-- Autres projets -->
                    <template v-if="regularVisible.length">
                        <div class="section-label">Projets</div>
                        <ul class="project-section">
                            <li
                                v-for="project of regularVisible"
                                :key="project.key"
                                :class="[{ active: activeProject === project, notified: notifications[project.key] }]"
                                @click="selectProject(project)">
                                <Avatar :avatar="project.avatar" :color="project.avatarColor" />
                                <div class="project-info">
                                    <span class="project-title">{{ project.title }}</span>
                                    <div class="project-logos" v-if="project.logos && project.logos.length">
                                        <img
                                            v-for="logo in project.logos"
                                            :key="logo"
                                            :src="require('../assets/img/logos/' + logo + '.png')"
                                            :alt="logo"
                                            :title="logo" />
                                    </div>
                                </div>
                                <span class="notifications" v-if="notifications[project.key]">
                                    <font-awesome-icon icon="bell" />
                                </span>
                            </li>
                        </ul>
                    </template>
                </div>

                <div class="conversation-wrapper" v-show="!isMobile || !mobileShowList">
                <transition name="project-fade" mode="out-in" @after-enter="scrollToTop">
                    <div class="conversation" v-if="activeProject" :key="activeProject.key">
                        <div class="title">
                            <button class="menu-toggle" v-if="isMobile" @click="mobileShowList = !mobileShowList">
                                <font-awesome-icon icon="bars" />
                            </button>
                            <Avatar :avatar="activeProject.avatar" :color="activeProject.avatarColor" />
                            <span class="title-text">{{ activeProject.title }}</span>
                            <div class="header-actions">
                                <a v-if="activeProject.github" :href="activeProject.github" target="_blank" class="header-link" title="GitHub">
                                    <svg viewBox="0 0 16 16" width="18" height="18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
                                    </svg>
                                </a>
                                <a v-if="activeProject.demo" :href="activeProject.demo" target="_blank" class="header-link" title="Demo">
                                    <svg viewBox="0 0 16 16" width="18" height="18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.604 1h4.146a.25.25 0 01.25.25v4.146a.25.25 0 01-.427.177L13.03 4.03 9.28 7.78a.75.75 0 01-1.06-1.06l3.75-3.75-1.543-1.543A.25.25 0 0110.604 1zM3.75 2A1.75 1.75 0 002 3.75v8.5c0 .966.784 1.75 1.75 1.75h8.5A1.75 1.75 0 0014 12.25v-3.5a.75.75 0 00-1.5 0v3.5a.25.25 0 01-.25.25h-8.5a.25.25 0 01-.25-.25v-8.5a.25.25 0 01.25-.25h3.5a.75.75 0 000-1.5h-3.5z"/>
                                    </svg>
                                </a>
                            </div>
                            <img v-for="(logo, index) in activeProject.logos" :key="index" height="20"
                                :src="require('../assets/img/logos/' + logo + '.png')" :alt="logo" :title="logo">
                        </div>

                        <div class="messages" ref="conversation">

                            <div class="message-wrapper" v-for="(message, index) of activeProject.messages" :key="index">
                                <template v-if="message.me">
                                    <div class="message">
                                        <template>
                                            <Avatar :color="'rgb(37, 128, 205)'" />
                                            <span> Giovanni </span>
                                            <span class="createdAt"> {{ formatDate(new Date(message.createdAt)) }} </span>
                                        </template>
                                    </div>

                                    <div class="message-content" v-html="message.content"></div>
                                </template>

                                <template v-else>
                                    <div class="message">
                                        <template>
                                            <Avatar :avatar="message.User.avatar"
                                                :color="message.User.avatarColor" />
                                            <form @submit.prevent="sendNickname"
                                                v-if="message.User.id === userId && form.nickname.edit">
                                                <input type="text" placeholder="Pseudo" v-model="form.nickname.value"
                                                    autofocus>
                                            </form>
                                            <span v-else>{{ password ? message.User.nickname || message.User.id :
                                                message.User.nickname || 'Vous' }}</span>
                                            <span class="createdAt"> {{ formatDate(new Date(message.createdAt)) }} </span>
                                        </template>
                                    </div>

                                    <div class="message-content" v-html="message.content"></div>
                                </template>
                            </div>

                            <div class="message-wrapper">
                                <div class="message">
                                    <Avatar :avatar="activeProject.avatar" :color="activeProject.avatarColor" />
                                    <span>{{ activeProject.title }}</span>
                                </div>

                                <div class="carousel" v-if="activeProject.carousel">
                                    <Carousel :images="activeProject.carousel.map(name => `/img/${activeProject.key}/${name}`)" />
                                </div>

                                <div class="skeleton-wrapper" v-if="descriptionLoading">
                                    <div class="skeleton-line"></div>
                                    <div class="skeleton-line short"></div>
                                    <div class="skeleton-line"></div>
                                    <div class="skeleton-line medium"></div>
                                    <div class="skeleton-line short"></div>
                                </div>

                                <div class="message-content" v-else v-html="projectDescription"></div>
                            </div>

                        </div>

                        <form class="input" @submit.prevent="send">
                            <input :type="activeProject.key === 'giovanni' && conversation.step === 'awaiting_email' ? 'email' : 'text'" v-model="form.message" :placeholder="activeProject.key === 'giovanni' && conversation.step === 'awaiting_email' ? 'Votre e-mail pour la réponse...' : $t('question')" />
                            <button type="submit" :disabled="!form.message">
                                <font-awesome-icon icon="paper-plane" />
                            </button>
                        </form>
                        <p class="input-disclaimer">
                            <font-awesome-icon icon="lock" /> Vos messages sont uniquement visibles par vous et moi
                        </p>
                    </div>
                </transition>
                </div>
            </div>
        </div>
        </div>
        </transition>
    </div>
</template>

<script>
import Avatar from './Avatar.vue';
import moment from 'moment';
import { projects, user } from '../data.js';
import { marked } from "marked";
import axios from 'axios';
import Carousel from './Carousel.vue';

export default {
    beforeMount() {
        this.projects = projects.map(p => ({ ...p, hide: false }));
        this.user = user;
        this.projects.unshift({
            key: 'giovanni',
            title: 'Giovanni',
            avatar: 'moi.webp',
            messages: [],
            hide: false,
        });

        // Restore active project from URL query param
        const queryKey = this.$route && this.$route.query.project;
        if (queryKey) {
            const found = this.projects.find(p => p.key === queryKey);
            this.activeProject = found || this.projects[0];
        } else {
            this.activeProject = this.projects[0];
        }

        const savedEmail = localStorage.getItem('user-email');
        if (savedEmail) {
            this.conversation.email = savedEmail;
        }
    },
    mounted() {
        this._handleKeyDown = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                this.$refs.searchInput && this.$refs.searchInput.focus();
            }
        };
        this._handleResize = () => {
            this.isMobile = window.innerWidth <= 710;
        };
        this.isMobile = window.innerWidth <= 710;
        window.addEventListener('keydown', this._handleKeyDown);
        window.addEventListener('resize', this._handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this._handleKeyDown);
        window.removeEventListener('resize', this._handleResize);
    },
    components: {
        Avatar,
        Carousel,
    },
    computed: {
        allTechs() {
            const techs = new Set();
            this.projects.forEach(p => {
                if (p.logos && p.key !== 'giovanni') {
                    p.logos.forEach(l => techs.add(l));
                }
            });
            return Array.from(techs).sort();
        },
        pinnedVisible() {
            return this.projects.filter(p => p.key !== 'giovanni' && p.pinned && !p.hide);
        },
        regularVisible() {
            return this.projects.filter(p => p.key !== 'giovanni' && !p.pinned && !p.hide);
        },
    },
    data() {
        return {
            form: {
                search: undefined,
                message: undefined,
                nickname: {
                    edit: false,
                    value: undefined,
                },
            },
            conversation: {
                email: '',
                question: '',
                step: 'start',
            },
            user: undefined,
            notifications: {},
            activeProject: undefined,
            projects: [],
            projectDescription: '',
            descriptionLoading: false,
            selectedTechs: [],
            techFilterOpen: false,
            mobileShowList: true,
            isMobile: false,
            isFullscreen: false,
            isMinimized: false,
            isClosed: false,
        };
    },
    methods: {
        selectProject(project) {
            this.activeProject = project;
            if (window.innerWidth <= 710) this.mobileShowList = false;
        },
        applyFilters() {
            const search = this.form.search ? this.form.search.toLowerCase() : '';
            const techs = this.selectedTechs;
            for (let project of this.projects) {
                if (project.key === 'giovanni') {
                    project.hide = false;
                    continue;
                }
                const matchesSearch = !search || project.title.toLowerCase().includes(search);
                const matchesTech = !techs.length || techs.some(t => project.logos && project.logos.includes(t));
                this.$set(project, 'hide', !(matchesSearch && matchesTech));
            }
        },
        toggleTechFilter(tech) {
            const idx = this.selectedTechs.indexOf(tech);
            if (idx === -1) this.selectedTechs.push(tech);
            else this.selectedTechs.splice(idx, 1);
            this.applyFilters();
        },
        formatDate(date) {
            return moment(date).format('L') + ' ' + moment(date).format('LT');;
        },
        scrollToBottom() {
            this.$nextTick(() => {
                if (this.$refs.conversation) {
                    this.$refs.conversation.scrollTop = 0;
                }
            });
        },
        scrollToTop() {
            this.$nextTick(() => {
                if (this.$refs.conversation) {
                    this.$refs.conversation.scrollTop = this.$refs.conversation.scrollHeight;
                }
            });
        },
        send() {
            if (!this.form.message) return;

            const userMessageContent = this.form.message;

            this.activeProject.messages.unshift({
                content: userMessageContent,
                createdAt: new Date(),
                User: { nickname: "Vous", avatarColor: 'rgb(37, 128, 205)' },
            });
            this.form.message = '';

            if (this.conversation.step === 'start') {
                this.conversation.question = userMessageContent;

                if (this.conversation.email) {
                    setTimeout(() => {
                        axios.post('https://contact.scarpellino.fr/send-email', {
                            projectTitle: this.activeProject.title,
                            message: this.conversation.question,
                            email: this.conversation.email
                        }).then(() => {
                            this.activeProject.messages.unshift({
                                content: "Message bien reçu ! Je vous répondrai sur l'e-mail que vous m'avez déjà fourni. 👍",
                                createdAt: new Date(),
                                me: false,
                                User: { title: this.activeProject.title, avatar: this.activeProject.avatar, nickname: this.activeProject.title }
                            });
                        }).catch(() => {
                            this.activeProject.messages.unshift({
                                content: "Oups, il y a eu un problème en envoyant votre message. Veuillez réessayer plus tard.",
                                createdAt: new Date(),
                                me: false,
                                User: { title: this.activeProject.title, avatar: this.activeProject.avatar, nickname: this.activeProject.title }
                            });
                        });

                        this.conversation.step = 'done';
                        this.scrollToBottom();
                    }, 500);
                } else {
                    setTimeout(() => {
                        axios.post('https://contact.scarpellino.fr/send-email', {
                            projectTitle: this.activeProject.title,
                            message: this.conversation.question,
                            email: ''
                        });

                        this.activeProject.messages.unshift({
                            content: "Parfait ! Pour que je puisse vous répondre, n'hésitez pas à me communiquer votre adresse e-mail.",
                            createdAt: new Date(),
                            me: false,
                            User: { title: this.activeProject.title, avatar: this.activeProject.avatar, nickname: this.activeProject.title }
                        });
                        this.conversation.step = 'awaiting_email';
                        this.scrollToBottom();
                    }, 500);
                }
            } else if (this.conversation.step === 'awaiting_email') {
                const userEmail = userMessageContent;
                this.conversation.email = userEmail;
                localStorage.setItem('user-email', userEmail);

                setTimeout(() => {
                    axios.post('https://contact.scarpellino.fr/send-email', {
                            projectTitle: this.activeProject.title,
                            message: this.conversation.question,
                            email: this.conversation.email
                    }).then(() => {
                        this.activeProject.messages.unshift({
                            content: "Message bien reçu ! Je vous répondrai sur l'e-mail que vous m'avez déjà fourni. 👍",
                            createdAt: new Date(),
                            me: false,
                            User: { title: this.activeProject.title, avatar: this.activeProject.avatar, nickname: this.activeProject.title }
                        });
                    }).catch(() => {
                        this.activeProject.messages.unshift({
                            content: "Oups, il y a eu un problème en envoyant votre message. Veuillez réessayer plus tard.",
                            createdAt: new Date(),
                            me: false,
                            User: { title: this.activeProject.title, avatar: this.activeProject.avatar, nickname: this.activeProject.title }
                        });
                    });

                    this.conversation.step = 'done';
                    this.scrollToBottom();
                }, 500);
            }
            this.scrollToBottom();
        },
        editNickname(nickname) {
            this.form.nickname.value = nickname || 'Vous';
            this.form.nickname.edit = true
        },
        sendNickname() {
            this.user.nickname = this.form.nickname.value;
            this.form.nickname.edit = false;
        }
    },
    watch: {
        'form.search'() {
            this.applyFilters();
        },
        activeProject: {
            async handler(project) {
                if (!project) return;
                this.$set(this.notifications, project.key, false);

                this.conversation.step = 'start';
                this.conversation.question = '';

                // Update URL query param for deep linking
                if (this.$route && this.$route.query.project !== project.key) {
                    this.$router.replace({ query: { project: project.key } }).catch(() => {});
                }

                if (project && project.markdown) {
                    this.descriptionLoading = true;
                    this.projectDescription = '';
                    try {
                        const markdownModule = await import(`@/assets/markdown/${project.key}.md`);
                        this.projectDescription = marked(markdownModule.default);
                    } catch (e) {
                        console.error(e);
                        this.projectDescription = 'Error loading markdown.';
                    } finally {
                        this.descriptionLoading = false;
                    }
                } else if (project) {
                    this.descriptionLoading = false;
                    this.projectDescription = this.$t('projects.' + project.key);
                } else {
                    this.descriptionLoading = false;
                    this.projectDescription = '';
                }

                this.scrollToTop();
            },
            immediate: true
        },
    },
};
</script>

<style lang="scss" scoped>
$normal: rgb(42, 43, 47);
$accent: rgb(37, 128, 205);
$border-radius: 15px;


.projects {
    min-height: 80vh;
    background: #fff;

    .navigator {
        box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.5);
        -webkit-box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.5);
        -moz-box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.5);

        border-radius: $border-radius;

        .actions {
            padding: 10px;

            .close,
            .minus,
            .zoom {
                height: 15px;
                width: 15px;
                border-radius: 50%;
                display: inline-block;
                margin-right: 10px;
                cursor: pointer;
                transition: opacity 0.15s;

                &:hover { opacity: 0.75; }
            }

            .close {
                background: #ed6a5e;
            }

            .minus {
                background: #f5bf4f;
            }

            .zoom {
                background: #61c554;
            }
        }

        max-width: 80%;
        margin: 5em auto;
        background: $normal;
        transition: max-width 0.4s ease, margin 0.4s ease, border-radius 0.4s ease;

        &.fullscreen {
            max-width: 100%;
            margin: 0;
            border-radius: 0;

            .content { height: 100vh; }
        }

        &.minimized {
            .content { display: none; }
        }

        .content {
            display: flex;
            background: darken($normal, 3);
            height: 80vh;
            transition: height 0.4s ease;

            .left {
                overflow: auto;
                min-width: 220px;
                max-width: 220px;

                .search {
                    input {
                        margin-top: 1em;
                        height: 20px;
                    }
                }

                .divider {
                    padding: 12.3px;
                    border-bottom: 2px solid lighten($normal, 3);
                    color: rgb(140, 140, 140);
                    font-size: 15px;
                }

                .tech-filter {
                    .tech-filter-toggle {
                        display: flex;
                        align-items: center;
                        gap: 7px;
                        width: 100%;
                        background: transparent;
                        border: none;
                        color: rgb(130, 130, 130);
                        font-size: 13px;
                        padding: 0;
                        cursor: pointer;
                        text-align: left;

                        &:hover { color: #fff; }

                        .filter-count {
                            background: rgba(255, 255, 255, 0.15);
                            border-radius: 10px;
                            font-size: 10px;
                            padding: 1px 6px;
                            color: #fff;
                        }

                        .chevron {
                            margin-left: auto;
                            font-size: 10px;
                            transition: transform 0.2s;
                            &.open { transform: rotate(180deg); }
                        }
                    }

                    .tech-chips {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 5px;
                        padding: 10px 0 2px;
                    }

                    .tech-chip {
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        background: darken($normal, 1);
                        border: 1px solid transparent;
                        border-radius: 20px;
                        color: rgb(130, 130, 130);
                        font-size: 11px;
                        padding: 4px 9px 4px 6px;
                        cursor: pointer;
                        transition: all 0.15s;

                        img {
                            width: 13px;
                            height: 13px;
                            object-fit: contain;
                            opacity: 0.45;
                        }

                        &:hover {
                            color: #fff;
                            border-color: rgba(255, 255, 255, 0.15);

                            img { opacity: 0.8; }
                        }

                        &.active {
                            border-color: rgba(255, 255, 255, 0.25);
                            color: #fff;
                            background: lighten($normal, 5);

                            img { opacity: 1; }
                        }
                    }
                }

                .section-label {
                    padding: 10px 15px 4px;
                    font-size: 10px;
                    text-transform: uppercase;
                    letter-spacing: 0.07em;
                    color: rgb(90, 90, 95);
                    font-weight: bold;
                }

                .project-section {
                    padding: 0;
                    margin: 0;
                    min-width: 200px;

                    li {
                        position: relative;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        list-style: none;
                        padding: 10px 15px;
                        color: rgb(140, 140, 140);
                        gap: 10px;

                        &.active {
                            background: $normal;
                            color: #fff;

                            .project-logos img {
                                opacity: 0.8;
                            }
                        }

                        &.notified {
                            color: #fff;
                        }

                        .project-info {
                            flex: 1;
                            overflow: hidden;

                            .project-title {
                                display: block;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                font-size: 14px;
                            }

                            .project-logos {
                                display: flex;
                                gap: 4px;
                                margin-top: 4px;

                                img {
                                    width: 13px;
                                    height: 13px;
                                    object-fit: contain;
                                    opacity: 0.45;
                                }
                            }
                        }


                        .notifications {
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            right: 10px;
                            border-radius: 50%;
                            height: 15px;
                            width: 15px;
                            font-size: 1em;
                            font-weight: bold;
                            text-align: center;
                            color: #fff;
                        }
                    }
                }
            }

            .conversation-wrapper {
                flex: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden;
            }

            .conversation {
                display: flex;
                flex-direction: column;
                flex: 1;
                background: lighten($normal, 3);
                color: #fff;
                overflow: auto;

                .title {
                    display: flex;
                    align-items: center;
                    padding: 15px;
                    border-bottom: 2px solid darken($normal, 3);
                    gap: 8px;
                    overflow: hidden;


                    .title-text {
                        flex: 1;
                        min-width: 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    img {
                        flex-shrink: 0;
                    }

                    .header-actions {
                        display: flex;
                        align-items: center;
                        margin-left: auto;
                        gap: 10px;
                        flex-shrink: 0;

                        .header-link {
                            color: rgb(120, 120, 125);
                            display: flex;
                            align-items: center;
                            text-decoration: none;
                            transition: color 0.15s;

                            &:hover {
                                color: #fff;
                            }
                        }
                    }
                }

                .messages {
                    flex: 1;
                    display: flex;
                    flex-direction: column-reverse;
                    padding: 15px;
                    overflow: auto;

                    input {
                        width: auto;
                    }

                    .message-wrapper {
                        .message {
                            display: flex;
                            align-items: center;
                            font-weight: bold;

                            .createdAt {
                                margin-left: 0.3em;
                                font-size: 0.7em;
                                opacity: 0.5;
                                padding-top: 4px;
                            }

                            .edit {
                                cursor: pointer;
                            }
                        }

                        .message-content {
                            margin: 0;
                            padding-left: 50px;
                            line-height: 1.6em;
                            padding-right: 15px;
                        }

                        .skeleton-wrapper {
                            padding-left: 50px;
                            padding-right: 15px;
                            padding-top: 10px;

                            .skeleton-line {
                                height: 13px;
                                background: rgba(255, 255, 255, 0.08);
                                border-radius: 6px;
                                margin-bottom: 10px;
                                animation: skeleton-pulse 1.6s ease-in-out infinite;

                                &.short {
                                    width: 55%;
                                }

                                &.medium {
                                    width: 75%;
                                }
                            }
                        }
                    }
                }

                .input-disclaimer {
                    text-align: center;
                    font-size: 0.72em;
                    color: rgb(90, 90, 90);
                    margin: -8px 15px 12px;

                    svg {
                        font-size: 0.9em;
                        margin-right: 4px;
                    }
                }

                .input {
                    display: flex;
                    align-items: center;
                    margin: 0 15px 8px;
                    background: darken($normal, 1);
                    border-radius: 8px;

                    input {
                        flex: 1;
                        background: transparent;
                        border: none;
                        padding: 15px;
                        color: #fff;
                        font-size: 1em;
                        outline: none;

                        &::placeholder {
                            color: rgb(140, 140, 140);
                        }
                    }

                    button {
                        background: transparent;
                        border: none;
                        color: rgb(140, 140, 140);
                        padding: 0 15px;
                        cursor: pointer;
                        font-size: 1.2em;

                        &:hover {
                            color: #fff;
                        }

                        &:disabled {
                            color: rgb(100, 100, 100);
                            cursor: not-allowed;
                        }
                    }
                }
            }
        }
    }
}

// Transition entre projets
.project-fade-enter-active,
.project-fade-leave-active {
    transition: opacity 0.15s ease;
}

.project-fade-enter,
.project-fade-leave-to {
    opacity: 0;
}

.filter-expand-enter-active,
.filter-expand-leave-active {
    transition: opacity 0.2s ease, max-height 0.25s ease;
    max-height: 300px;
    overflow: hidden;
}

.filter-expand-enter,
.filter-expand-leave-to {
    opacity: 0;
    max-height: 0;
}

// Skeleton animation
@keyframes skeleton-pulse {
    0%   { opacity: 0.4; }
    50%  { opacity: 0.8; }
    100% { opacity: 0.4; }
}

@media (max-width: 710px) {
    .projects {
        min-height: 100vh;
        background: $normal;

        .navigator {
            margin: 0;
            border-radius: 0;
            max-width: 100%;

            .actions { display: none; }

            .content {
                height: 100vh;
                flex-direction: column;

                .left {
                    min-width: 100%;
                    max-width: 100%;
                    height: 100vh;
                }

                .conversation-wrapper {
                    min-width: 100%;
                    height: 100vh;
                    display: flex;
                    flex-direction: column;

                    .conversation {
                        height: 100vh;

                        .title {
                            .title-text {
                                flex: 1;
                                min-width: 0;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            img { display: none; }
                        }
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
$normal: rgb(42, 43, 47);

.message-content {
    .embed {
        background: darken($normal, 4);
        padding: 15px;
        border-radius: 15px;
    }

    a {
        color: rgb(37, 128, 205);
    }
}

.projects-inner {
    width: 100%;
}

.closed-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 60px 20px;
    color: rgb(100, 100, 105);
    font-size: 15px;

    .closed-icon {
        font-size: 48px;
        filter: grayscale(1);
        opacity: 0.5;
    }

    p { margin: 0; }

    button {
        background: rgb(42, 43, 47);
        border: none;
        color: #fff;
        padding: 8px 20px;
        border-radius: 8px;
        cursor: pointer;
        font-size: 14px;
        transition: opacity 0.15s;

        &:hover { opacity: 0.8; }
    }
}

.closed-fade-enter-active,
.closed-fade-leave-active {
    transition: opacity 0.25s ease;
}

.closed-fade-enter,
.closed-fade-leave-to {
    opacity: 0;
}

.menu-toggle {
    background: transparent;
    border: none;
    color: rgb(140, 140, 140);
    cursor: pointer;
    padding: 0;
    font-size: 1em;
    flex-shrink: 0;
    line-height: 1;

    &:hover { color: #fff; }
}
</style>
